import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDUf7AhAeiPpn8o2zdmDOAjIYWOurAvVkE",
  authDomain: "sonom-e1fb9.firebaseapp.com",
  projectId: "sonom-e1fb9",
  storageBucket: "sonom-e1fb9.firebasestorage.app",
  messagingSenderId: "703601353714",
  appId: "1:703601353714:web:7578731cf6206c0f97816b",
  measurementId: "G-56F6WYVJ8R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;